import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Compass, AlertCircle } from "lucide-react";
import { toast } from "sonner";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Lands at /auth/google/callback#session_id=...
 * Exchanges session_id with backend → JWT → store → redirect home
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setError("Sessione mancante");
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id });
        localStorage.setItem("odismap_token", data.access_token);
        localStorage.setItem("odismap_user", JSON.stringify(data.user));
        await refresh();
        toast.success(`Bentornato ${data.user.name}!`);
        // Pulisci fragment dall'URL prima di navigare
        window.history.replaceState({}, document.title, "/");
        navigate("/", { replace: true });
      } catch (e) {
        const msg = e.response?.data?.detail || "Login Google fallito";
        setError(msg);
        toast.error(msg);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-parchment-grain flex items-center justify-center p-4" data-testid="auth-callback-page">
      <div className="card-treasure p-8 max-w-md w-full text-center">
        <div className="w-16 h-16 mx-auto rounded-3xl bg-gold flex items-center justify-center shadow-tactile mb-3 animate-pulse">
          <Compass className="text-ink-900" size={32} strokeWidth={2.6} />
        </div>
        {error ? (
          <div className="flex items-center gap-2 justify-center text-compass bg-red-50 p-3 rounded-xl border border-red-200" data-testid="auth-callback-error">
            <AlertCircle size={18}/> {error}
            <button onClick={()=>navigate("/login")} className="ml-2 underline" data-testid="back-to-login">Torna al login</button>
          </div>
        ) : (
          <>
            <div className="font-display font-extrabold text-2xl text-ink-900">Accesso in corso…</div>
            <p className="text-ink-500 text-sm mt-2">Verifica della sessione Google</p>
          </>
        )}
      </div>
    </div>
  );
}
